export const PRICE_BOOKS_RESET_STATE = 'PRICE_BOOKS_RESET_STATE';
export const PRICE_BOOKS_CURRENT_ITEM = 'PRICE_BOOKS_CURRENT_ITEM';

export const PRICE_BOOKS_REQUEST_LOADING = 'PRICE_BOOKS_REQUEST_LOADING';
export const PRICE_BOOKS_REQUEST_SUCCESS = 'PRICE_BOOKS_REQUEST_SUCCESS';
export const PRICE_BOOKS_REQUEST_FAILED = 'PRICE_BOOKS_REQUEST_FAILED';

export const PRICE_BOOKS_CURRENT_ACTION = 'PRICE_BOOKS_CURRENT_ACTION';
export const PRICE_BOOKS_RESET_ACTION = 'PRICE_BOOKS_RESET_ACTION';